// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import jquery from "jquery";
import animated from "animate.css";
import ElementUI from 'element-ui';
// import axios from 'axios'//引入axios
import 'element-ui/lib/theme-chalk/index.css';
// import 'normalize.css/normalize.css';
import './assets/css/app.css';
import store from './store'

// import "swiper/swiper.min.css";

Vue.use(ElementUI);
Vue.use(animated)
Vue.config.productionTip = false
// Vue.prototype.$axios = axios;//把axios挂载到vue上
Vue.prototype.$ = jquery;

Vue.config.productionTip = process.env.NODE_ENV === 'development'; //production生产环境  development开发环境

//路由守卫登录及权限判断
router.beforeEach((to,from,next)=>{
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') //是否登录
  let str = []
  let arr = []
  if(sessionStorage.getItem('limits')){
    str = sessionStorage.getItem('limits');
    arr = str.split(",");
  }
  let isnext = false //是否有权限
  if(to.name == 'login' || isLoggedIn == 'true' ){
      next();
  }else{
    // alert('您还没有登录，请先登录');
    generatemessage('您还没有登录，请先登录',2000)
    next('/login');
  }
  if(isLoggedIn == 'true' && to.name != 'login'){
    for (let i = 0; i < arr.length; i++) {
      if(to.name == arr[i] || to.name == 'login' || arr[i] == '*' ){
        isnext = true
        break;
      }
    }
    console.log(from.path);
    if(isnext){
      if(arr[0] == '*' || from.path != '/login'){
        next();
      }else{
        next(arr[0]);
      }
    }else{
      router.replace(from.path); // 返回上一个路由
      generatemessage('无权限',2000)
    }
  }
})

function generatemessage(msg,time){  //生成提示框
    const messageBox = document.createElement('div');
    messageBox.className = 'promptbox'
    messageBox.textContent = msg;
    messageBox.style.position = 'fixed';
    messageBox.style.transition = 'all .3s';
    messageBox.style.opacity = '0';
    messageBox.style.top = '50%';
    messageBox.style.left = '50%';
    messageBox.style.transform = 'translate(-50%, -50%)';
    messageBox.style.padding = '20px 40px';
    messageBox.style.background = '#000';
    messageBox.style.color = '#fff';
    messageBox.style.borderRadius = '5px';
    messageBox.style.fontFamily = 'Arial, sans-serif';
    messageBox.style.fontSize = '18px';
    messageBox.style.zIndex = '9999';
    document.body.appendChild(messageBox);
    setTimeout(() => {
        messageBox.style.opacity = '1';
    }, 1);
    setTimeout(() => {
        messageBox.style.opacity = '0';
    }, 1700);
    setTimeout(function () {
        document.body.removeChild(messageBox);
    }, time);
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js